import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { HemaHeadingWithSubText, HemaLabel, Button, HemaValue, Alert } from '../../utils';
import { LoginEmail, EyeIcon, CrossIcon, PassLock, HideEye } from '../../HemeIconLibrary';
import { showErrorReducer } from '../../Store/reducers/uiSettings';
import { LoginAction } from '../../Actions/auth';
import { getUserDetailsAction } from '../../Actions/user';
import LoginInput from '../../utils/FormElements/loginInput';
import { Link } from 'react-router-dom';
import { setActiveSponsor, setFilterSite, setFilterStudy } from '../../Store/reducers/users';
import MfaForm from "./mfaPage";

const LoginForm = ({ setFirstAttemptToSelectDropdown }) => {
  const [showPassword, setshowPassword] = useState(false);
  const [showMfa, setShowMfa] = useState(false);
  const [initialMfaCooldown, setInitialMfaCooldown] = useState(0);

  const currentYear = new Date().getFullYear();
  const dispatch = useDispatch();
  
  const handleMfaVerified = async (token) => {
    localStorage.setItem("hema-token", token.accessToken);
    localStorage.setItem(
      "hema-token-first",
      `${token?.user?.firstName} ${token?.user?.lastName}`
    );
    localStorage.setItem("hema-token-refresh", token.refreshToken);

    const stats = await getUserDetailsAction();
    dispatch(setActiveSponsor(stats?.data?.sponsors?.[0]));
    dispatch(
      setFilterStudy(
        stats?.data.studies?.filter(
          (study) => study.parentId === stats?.data.sponsors?.[0]?.id
        )
      )
    );
    dispatch(
      setFilterSite(
        stats?.data.sites?.filter(
          (site) => site.parentId === stats?.data.studies?.[0]?.id
        )
      )
    );

    if (stats?.status === 200) {
      setFirstAttemptToSelectDropdown(true);
    }
  };

  return (
    <div className="max-w-full lg:max-w-[450px]">
      <Alert type="error" />
      {!showMfa && (
      <HemaHeadingWithSubText heading="Log In" sub="" subTextColor="#595959" />
      )}
      <Formik
        initialValues={{ email: '', password: '' }}
        enableReinitialize
        validate={(values) => {
          const errors = {};
          if (showMfa) {
            dispatch(showErrorReducer(""));
            return errors;
          }
          if (!values.email) {
            errors.email = 'Required';
          } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
            errors.email = 'Please enter correct email format';
          }

          if (!values.password) {
            errors.password = 'Required';
          }
          dispatch(showErrorReducer(''));
          return errors;
        }}
        onSubmit={async (values, { setSubmitting }) => {
          const result = await LoginAction(values);

          if (result?.status === 200) {
            if (result?.data?.requireMfa || result?.data?.RequireMfa) {
              dispatch(showErrorReducer(""));
              const ttl = Number(result?.data?.mfaRetryAfterSeconds);
              setInitialMfaCooldown(Number.isFinite(ttl) && ttl >= 0 ? ttl : 60);
              setShowMfa(true);
              setSubmitting(false);
              return;
            }
            localStorage.setItem('hema-token', result.data.token.accessToken);
            localStorage.setItem('hema-token-first', `${result.data.token?.user?.firstName} ${result.data.token?.user?.lastName}`);
            localStorage.setItem('hema-token-refresh', result.data.token.refreshToken);

            const stats = await getUserDetailsAction();
            dispatch(setActiveSponsor(stats?.data?.sponsors?.[0]));
            dispatch(setFilterStudy(stats?.data.studies?.filter((s) => s.parentId === stats?.data.sponsors?.[0]?.id)));
            dispatch(setFilterSite(stats?.data.sites?.filter((site) => site.parentId === stats?.data.studies?.[0]?.id)));

            setSubmitting(false);
            if (stats.status === 200) setFirstAttemptToSelectDropdown(true);
          } else {
            dispatch(showErrorReducer(result?.message));
            setSubmitting(false);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
          /* and other goodies */
        }) => (
          <>
          {showMfa ? (
            <div className="mt-6">
              <MfaForm email={values.email} onVerified={handleMfaVerified} onCancel={() => { dispatch(showErrorReducer("")); setShowMfa(false); }} initialResendIn={60} />
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="mt-[24px]">{/* <Alert type="error" /> */}</div>

              <div className="flex flex-col  mb-[24px] mt-[24px]">
                <HemaLabel text="Email" Icon={<LoginEmail />} textSize="text-[16px]" />
                <LoginInput
                  type="email"
                  name="email"
                  placeholder="Enter your Email"
                  crossIcon={values.email ? <CrossIcon /> : ''}
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  setFieldValue={setFieldValue}
                />
                <p className="error m-0  text-[#F54C3B]">{errors.email && touched.email && errors.email}</p>
              </div>

              <div className="flex flex-col mb-[15px]">
                <HemaLabel text="Password" Icon={<PassLock />} textSize="text-[16px]" />
                <LoginInput
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  placeholder="Enter Password"
                  inputIcon={!values.password ? '' : !showPassword ? <EyeIcon /> : <HideEye />}
                  crossIcon={values.password ? <CrossIcon /> : ''}
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  setshowPassword={setshowPassword}
                  showPassword={showPassword}
                  setFieldValue={setFieldValue}
                />
                <p className="error m-0  text-[#F54C3B] ">{errors.password && touched.password && errors.password}</p>
              </div>

              <div className="flex justify-between items-center">
                <div className="flex gap-[8px]">
                  <input type="checkbox" id="rememberMe" name="remember-me" value="remember me" className="w-[20px]" />
                  {/* <label for="remember-me"> Remember me</label> */}
                  <HemaLabel text=" Remember me" textSize="text-[14px]" />
                </div>
                <Link className="no-underline" to="/forgot-password">
                  <HemaValue text="Forgot Password" color="text-[#F54C3B]" className="cursor-pointer" />
                </Link>
              </div>
              <div className="my-4">
                <p>By signing into this portal, I'm indicating that the information contained herein is confidential, and I shall comply with Company policies, including terms of use, confidentiality, security and privacy.
                </p>
              </div>
              {isSubmitting ? (
                <Button
                  type="button"
                  bg="bg-primary1"
                  className="w-full h-[48px] justify-center font-semibold"
                  text={
                    <>
                      <Spinner animation="grow" size="sm" variant="light" />
                      <Spinner animation="grow" size="sm" variant="light" />
                      <Spinner animation="grow" size="sm" variant="light" />
                    </>
                  }
                />
              ) : (
                <Button
                  text="Log In"
                  type="submit"
                  bg="bg-primary1"
                  border="border-primary1"
                  color="text-white"
                  className="w-full h-[48px] justify-center font-semibold"
                  disabled={values.email && values.password && Object.keys(errors)?.length === 0 ? false : true}
                />
              )}
              <div className='flex justify-center gap-2 text-sm mt-4'>
                <Link className="no-underline text-[#F54C3B] font-medium" to="https://www.hematogenix.com/legal/terms-of-use">Terms of Use</Link>
                |
                <Link className="no-underline text-[#F54C3B] font-medium" to="https://www.hematogenix.com/legal/privacy-policy-and-cookies">Privacy Policy & Cookies</Link>
              </div>
              <p className='text-center w-100 text-sm'>©{currentYear} <Link to="https://www.hematogenix.com" className="no-underline text-[#F54C3B] font-medium">Hematogenix</Link></p>
              {process.env.REACT_APP_IS_CN_ENV && <p className='text-center w-100 text-sm'> 沪ICP备2025143012号-1 </p> }
            </form>
            )}
          </>
        )}
      </Formik>
    </div>
  );
};

export default LoginForm;
